import React from 'react';
import ReactDOM from 'react-dom';
import Slider from 'react-slick';

// Custom arrow components
const PrevArrow = (props) => {
	const { className, style, onClick } = props;
	// Add value to className
	return (
		<button
			type="button"
			className={`${className} kf-prev-arrow`}
			style={{ ...style }}
			onClick={onClick}
		>
			<i className="fas fa-chevron-left"></i>
		</button>
	);
};

const NextArrow = (props) => {
	const { className, style, onClick } = props;
	return (
		<button
			type="button"
			className={`${className} kf-next-arrow`}
			style={{ ...style }}
			onClick={onClick}
		>
			<i className="fas fa-chevron-right"></i>
		</button>
	);
};


document.addEventListener('DOMContentLoaded', function () {
	const sliderElements = document.querySelectorAll('.wp-block-kirkfield-slider');
	sliderElements.forEach((el) => {
		const slides = Array.from(el.children).map((child, idx) => {
			return React.createElement('div', { key: idx, dangerouslySetInnerHTML: { __html: child.outerHTML } });
		});
		ReactDOM.render(
			React.createElement(
				Slider,
				{
					dots: true,
					arrows: true,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					adaptiveHeight: true,
					prevArrow: <PrevArrow />,
					nextArrow: <NextArrow />,
				},
				slides
			),
			el
		);
	});
});
